import { Cushion, Grid, MaxWidth, Shadow, Space } from '@pitchero/react-ui';
import PropTypes from 'prop-types';
import React from 'react';
import TopBannerVideoPlayerSwitch from '../../adverts/top-banner-video-player-switch';
import NativeShelf from '../../native-adverts/shelf';
import Table from '../../table';
import TableLoadingState from '../../table/loading-state';
import SeasonFilter from '../season-filter';
import { SEASONS_PROP_TYPES } from '../../../lib/prop-types/season';
import TABLE_PROP_TYPES from '../../../lib/prop-types/table';
import useBreakpoint from '../../../lib/use-breakpoint';
import MobileAppPromo from '../mobile-app-promo';
import MobileSubHeader from '../mobile-sub-header';
import NoResults from './no-results';
import TableFilter from './table-filter';

const TeamLeagueTable = ({
  club,
  isLoading,
  seasons,
  seasonId,
  tables,
  table,
  tableId,
  onSeasonFilterChange,
  onTableFilterChange,
}) => {
  const renderResults = () => (
    <>
      {seasons.length > 0 && (
        <Grid
          className="ie-grid-two-col"
          columns="1fr 1fr"
          columnGap="xlarge"
          rowGap="small"
          responsive={[{ maxWidth: 'palm', props: { columns: '1fr' } }]}
        >
          <SeasonFilter seasons={seasons} selected={seasonId} onChange={onSeasonFilterChange} />
          {tables.length > 0 && (
            <TableFilter tables={tables} selected={tableId} onChange={onTableFilterChange} />
          )}
        </Grid>
      )}
      <Space vertical="large" component="div">
        <MobileAppPromo link="https://pitchero.onelink.me/3472025876?pid=Text%20Link&c=Tables-Nov19&af_web_dp=https%3A%2F%2Fwww.pitchero.com%2Fclub-app" />
      </Space>
      <Space bottom="large" component="div">
        {table ? (
          <Shadow>
            <Table {...table} />
          </Shadow>
        ) : (
          <NoResults />
        )}
      </Space>
    </>
  );

  const { advertisingTier, sportId } = club;
  const isMobile = useBreakpoint();

  return (
    <MaxWidth component="div" maxWidth={1366} center>
      {isMobile && <MobileSubHeader title="Table" transKey="teams:navigation_league_table" />}
      <Cushion bottom="medium">
        <TopBannerVideoPlayerSwitch
          advertisingTier={advertisingTier}
          sportId={sportId}
          pageType="team.homepage"
        />
      </Cushion>
      {isLoading && <TableLoadingState />}
      {!isLoading && renderResults()}

      <NativeShelf paddingProps={{ bottom: 'medium' }} />
    </MaxWidth>
  );
};

TeamLeagueTable.defaultProps = {
  isLoading: true,
  table: null,
  seasonId: null,
  tableId: null,
};

TeamLeagueTable.propTypes = {
  club: PropTypes.shape({
    advertisingTier: PropTypes.number.isRequired,
    sportId: PropTypes.number.isRequired,
  }).isRequired,
  isLoading: PropTypes.bool,
  seasons: SEASONS_PROP_TYPES.isRequired,
  seasonId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  tables: PropTypes.arrayOf(TABLE_PROP_TYPES).isRequired,
  table: TABLE_PROP_TYPES,
  tableId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onSeasonFilterChange: PropTypes.func.isRequired,
  onTableFilterChange: PropTypes.func.isRequired,
};

export default TeamLeagueTable;
